;(function () {
  window.Ateed.Components.CreateEventPlan = function() {

      var searchWithRegionsAndSuburbs = new Array('stay','taste');

      for (var i = 0; i < searchWithRegionsAndSuburbs.length; i++) {
        $('.ateed-'+searchWithRegionsAndSuburbs[i]+'-search').each(function () {
            var el = this;
            var searchName = searchWithRegionsAndSuburbs[i];

            $('form',el).submit(function(e){
              e.preventDefault();
              $('[data-target="#resultsModal"]',el).click();
            });

            var viewModel = new Vue({
                el: el,
                data: {
                    region: null
                },
                methods: {
                    changeRegion: function (region) {
                        this.region = region;
                    }
                }
            });

            $(el).find('#'+searchName+'-region').on('change', function () {
                viewModel.changeRegion($(el).find('#'+searchName+'-region').val());
            });
            $(el).find('#'+searchName+'-region').trigger('change');
        });
      }

      $('.ateed-acb-search').each(function () {
          var el = this;

          $('form',el).submit(function(e){
            e.preventDefault();
            $('[data-target="#resultsModal"]',el).click();
          });

          var viewModel = new Vue({
              el: el,
              data: {
                  type: null
              },
              methods: {
                  changeType: function (type) {
                      this.type = type;
                  }
              }
          });

          $(el).find('#acb-type').on('change', function () {
              viewModel.changeType($(el).find('#acb-type').val());
          });

          $(document.body).on('change', $(el).find('select.form-control'), function (e) {
              setCookie('ateed-acb-search-' + e.target.id, $(el).find('#' + e.target.id).val());
          });
      });

      //get all cookies and look for any that start with "ateed-acb-search-"
      function decodeCookie() {
          var cookieParts = document.cookie.split(";"),
              cookies = {};

          for (var i = 0; i < cookieParts.length; i++) {
              var name_value = cookieParts[i],
                  equals_pos = name_value.indexOf("="),
                  name       = unescape(name_value.slice(0, equals_pos)).trim(),
                  value      = unescape(name_value.slice(equals_pos + 1));

              cookies[":" + name] = value; //purposely put in a colon at the start so then you don't get system cookies
          }
          return cookies;
      }

      //find all cookies by starting name
      function findCookiesByName(searchWord) {
          var cookies = decodeCookie();
          var c = [];

          for (name in cookies) {
              var value = cookies[name];
              if (name.indexOf(":" + searchWord) === 0) {
                  c.push({'name': name.substring(1).replace('ateed-acb-search-',''), 'value': value});
              }
          }

          return c;
      }

      //let's find the cookies and set those dropdowns
      var value = findCookiesByName("ateed-acb-search-");

      if (value.length > 0) {
          //must do type first or subsequent setting of values do not work
          var sel = getCookie('ateed-acb-search-acb-type');
          $('#acb-type').val(sel).trigger('change');

          //now loop through all the set cookies for search
          //and yes, setTimeout makes us wait for first dropdown to be set first
          setTimeout(function() {
              for (c in value) {
                  $('#' + value[c].name).val(value[c].value).trigger('change');
              }
          }, 1000);
      }

      //cookie functions for setting and retrieving, the duration I set is 24 hours only.
      function setCookie(key, value) {
          var expires = new Date();
          expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
          document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
      }

      function getCookie(key) {
          var key = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
          return key ? key[2] : null;
      }
  };
})();
